<template>
  <div class="classlayout">
    <el-main>
      <div class="div">
        <el-button
          type="primary"
          @click="addLink"
        >
          +&nbsp;新增关联
        </el-button>
      </div>
      <div class="div2">
        <div class="div2-br">
          <span>学段：</span>
          <div class="btn">
            <el-radio-group
              v-model="stageId"
              @change="changeStage"
            >
              <el-radio-button
                size="small"
                :label="item.id"
                v-for="(item, index) in stages"
                :key="index"
                >
                  {{ item.name }}
                </el-radio-button
              >
            </el-radio-group>
          </div>
        </div>
        <!-- <div class="div2-br">
          <span>资源：</span>
          <div class="btn">
            <el-radio-group
              v-model="materialId"
              @change="changeMaterial"
            >
              <el-radio-button
                size="small"
                :label="item.id"
                v-for="(item, index) in materials"
                :key="index"
                >
                  {{ item.name }}
                </el-radio-button
              >
            </el-radio-group>
          </div>
        </div> -->
        <div class="div2-br">
          <span>栏目：</span>
          <div class="btn">
            <el-radio-group
              v-model="columnId"
              @change="changeColumn"
            >
              <el-radio-button
                size="small"
                :label="item.id"
                v-for="(item, index) in columns"
                :key="index"
                >{{ item.name }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </div>
      </div>
      <el-table
        :data="links"
        :height="height"
        v-loading="loading"
        header-row-class-name="header-row-class-name"
        border
        style="width: 100%"
      >
        <el-table-column prop="name" label="类型名"> </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.used === true" style="color: #00ff00">
              启用</span
            >
            <span v-if="scope.row.used === false" style="color: #ff0000"
              >禁用</span
            >
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="dealColumnType(scope.row.id, false)"
              v-if="scope.row.used == true"
              >禁用</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="dealColumnType(scope.row.id, true)"
              v-if="scope.row.used == false"
              >启用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 编辑框 -->
      <link-dialog
        v-model="classDialogVisible"
        :types="types"
        @success="editSuccess"
      >
      </link-dialog>
    </el-main>
  </div>
</template>
<script type="text/babel">
import shijuanService from "@/service/shijuanService";
import linkDialog from "./edit-dialog/link";
import { tagMixins } from "./mixins/tagMixins";
export default {
  name: "shijuanTypeLink",
  mixins: [tagMixins],
  components: {
    linkDialog,
  },
  data() {
    return {
      classDialogVisible: false,
      height: this.SysConstant.winHeight - 280,
      links: [],
      loading: false
    };
  },
  async mounted() {
    // 查询
    await this.getStage();
    await this.getMaterial();
    await this.getColumn();
    await this.getType();
    await this.getColumnType();
  },
  methods: {
    async changeStage() {
      await this.changeTag('stageId');
      this.getColumnType();
    },
    async changeMaterial() {
      await this.changeTag('materialId');
      this.getColumnType();
    },
    async changeColumn() {
      await this.changeTag('columnId');
      this.getColumnType();
    },

    // 启用和禁用
    async dealColumnType(id, used) {
      let typeName = used ? "启用" : "禁用";
      this.$confirm(`此操作将该${typeName}试卷类型, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await shijuanService.shijuan_column_type_deal(id, used);
          this.getColumnType();
          this.$message.success(this.SysConstant.success);
        })
        .catch((e) => {
          this.$message.error(e && e.msg);
        });
    },
    addLink() {
      this.classDialogVisible = true;
    },
    async saveLink(typeId, columnId) {
      try {
        await shijuanService.shijuan_column_type_set(typeId, columnId);
        this.classDialogVisible = false;
        this.getColumnType();
      } catch (e) {
        this.$message.error(e && e.msg);
      }
    },
    editSuccess(typeId) {
      for (let i =0 ; i < this.links.length; i++) {
        if (this.links[i].column.id === this.columnId && this.links[i].detailType.id === typeId) {
          this.$message.error('栏目下已关联该资源');
          return;
        }
      }
      this.saveLink(typeId, this.columnId)
    },
  },
};
</script>
<style scoped>
.classlayout .div {
  background-color: #ffffff;
  color: #333;
  line-height: 60px;
  height: 60px;
  margin-top: -10px;
  margin-bottom: 5px;
}
.classlayout .div {
  margin-top: -10px;
}
.classlayout .div .el-button {
  background-color: #00aaff;
  color: #fff;
  margin: 10px;
  float: left;
}
.classlayout .div2 {
  background-color: #ffffff;
  color: #333;
  line-height: 60px;
  margin: 5px 0;
}
.classlayout .div2 .div2-br{
  overflow: hidden;
}

.classlayout .div2 span {
  margin: 0px 40px;
  float: left;
}
.classlayout .div2 .btn {
  float: left;
  width: 80%;
}
.classlayout .div2 .active {
  background-color: #00aaff;
  color: #fff;
}
</style>
<style type="text/css">
.classlayout .div2 .el-radio-button {
  margin: 10px 10px;
  border: none !important;
  border-radius: 4px !important;
}
.classlayout .el-radio-button__inner {
  border: 1px solid #dcdfe6;
}
</style>




// WEBPACK FOOTER //
// src/pages/layout/shijuan-manage/type-link.vue